/* @flow */

import React from 'react';
import Parser from 'html-react-parser';
import ListItem from '@mui/material/ListItem';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import SvgIcon from '@mui/material/SvgIcon';
import MANEUVER_SVG_PATHS from '../../../constants/maneuverSvgPaths';
import customstyles from './Directions.module.scss';

type Props = {
    steps: Object,
    index: number,
    onStepClick?: Function,
}

const DirectionsStepsDetails = (props : Props) => {
    const { steps, index, onStepClick } = props;

    const distance = steps.localizedValues?.distance?.text || '';
    const duration = steps.localizedValues?.staticDuration?.text || '';
    const instruction = steps.navigationInstruction ? steps.navigationInstruction.instructions : '';
    const text = instruction ? `${index + 1}. ${instruction}` : '';
    const maneuver = steps.navigationInstruction ? steps.navigationInstruction.maneuver : '';
    const latLng = steps.startLocation?.latLng;
    const location = (latLng && typeof latLng.latitude === 'number'
        && typeof latLng.longitude === 'number')
        ? { lat: latLng.latitude, lng: latLng.longitude }
        : null;

    const isClickable = typeof onStepClick === 'function' && !!location;
    // The maneuver icon is only relevant for interactive (clickable) step
    // lists, e.g. the dispatch panel - the read-only nearest-asset/landmark
    // list stays icon-less/compact, matching its original layout.
    const showManeuverIcon = typeof onStepClick === 'function';
    const handleClick = () => onStepClick({
        location, text, distance, duration, maneuver,
    });
    return (
        <ListItem
            button={isClickable}
            onClick={isClickable ? handleClick : undefined}
            className={`${customstyles['list-item']} ${customstyles.directionStepsList}`}
        >
            <Grid container spacing={1}>
                {showManeuverIcon &&
                    <Grid item xs={1} className={customstyles.gridItemDirections}>
                        <SvgIcon className={customstyles['direction-icon']} fontSize="small">
                            <path
                                d={
                                    MANEUVER_SVG_PATHS[maneuver]
                                    || MANEUVER_SVG_PATHS.STRAIGHT
                                }
                            />
                        </SvgIcon>
                    </Grid>
                }
                <Grid
                    item
                    xs={showManeuverIcon ? 8 : 9}
                    className={customstyles.gridItemDirections}
                >
                    <div className={customstyles['direction-desc']}>
                        {Parser(text)}
                    </div>
                </Grid>
                <Grid item xs={3} className={customstyles.gridItemDirections}>
                    <div>
                        <Typography paragraph className={customstyles['direction-distance-time']} align="right" component="p">
                            {duration}
                        </Typography>
                        <Typography className={customstyles['direction-distance-time']} align="right" >
                            {distance}
                        </Typography>
                    </div>
                </Grid>
            </Grid>
        </ListItem>
    );
};

DirectionsStepsDetails.defaultProps = {
    onStepClick: undefined,
};

export default (DirectionsStepsDetails);
